// Search route: hybrid search across the loaded grid codes of the region, with the query, version and result count in the URL.
import { createFileRoute, stripSearchParams } from "@tanstack/react-router";
import { z } from "zod";

import { optionalString, numberWithDefault } from "@/app/search";
import { SearchScreen } from "@/features/search/SearchScreen";

const searchSchema = z.object({
  q: z.string().default("").catch(""),
  doc: optionalString(),
  k: numberWithDefault(10, 1, 50),
});

const searchDefaults = { q: "", k: 10 } satisfies Partial<z.output<typeof searchSchema>>;

export const Route = createFileRoute("/_app/$region/search")({
  validateSearch: searchSchema,
  search: { middlewares: [stripSearchParams(searchDefaults)] },
  staticData: { crumb: "Search" },
  component: SearchRoute,
});

function SearchRoute() {
  return <SearchScreen search={Route.useSearch()} />;
}
